import { BUILD_PREFERENCES_STORAGE_KEY } from "~/components/build/Show/lib/useBuildPreferencesStore";
import { BUILD_FILTERS_STORAGE_KEY } from "~/components/build/Show/lib/useFilterStore";

export function clearPersistedBuildPagePreferences(): void {
  try {
    localStorage.removeItem(BUILD_PREFERENCES_STORAGE_KEY);
    localStorage.removeItem(BUILD_FILTERS_STORAGE_KEY);
  } catch {
    // localStorage can be unavailable in restricted browser contexts.
  }
}
